import {AssetUploadProperty} from "../upload.model";
import {AssetProperties, AssetPropertyValue} from "../../assets/asset.model";

export type PropertyUsages = { [key: string]: { [value: string]: number } };

export function union(properties: AssetProperties[]): AssetProperties {
    let result: { [key: string]: string[] } = {};
    for (let props of properties) {
        for (let key in props) {
            if (!result[key]) {
                result[key] = [];
            }
            let value = props[key];
            if (Array.isArray(value)) {
                for (let v of value) {
                    if (!result[key].includes(v)) {
                        result[key].push(v);
                    }
                }
            } else if (typeof value === 'string') {
                if (!result[key].includes(value)) {
                    result[key].push(value);
                }
            } else if (typeof value === 'boolean') {
                if (!result[key].includes(value.toString())) {
                    result[key].push(value.toString());
                }
            } else {
                let strValue = value.toISOString();
                if (!result[key].includes(strValue)) {
                    result[key].push(strValue);
                }
            }
        }
    }
    return result;
}

export function buildPropertyUsages(availableProperties: AssetUploadProperty[], chosenProperties: AssetProperties[]): PropertyUsages {
    let propertyUsage: PropertyUsages = {};
    for (let props of availableProperties) {
        propertyUsage[props.name] = {}
    }

    function incUsage(key: string, v: string) {
        if (!propertyUsage[key][v]) {
            propertyUsage[key][v] = 1;
        } else {
            propertyUsage[key][v] += 1;
        }
    }

    for (let props of chosenProperties) {
        for (let key in props) {
            if (!propertyUsage[key]) {
                propertyUsage[key] = {};
            }
            let value = props[key];
            if (Array.isArray(value)) {
                for (let v of value) {
                    incUsage(key, v);
                }
            } else if (typeof value === 'string') {
                incUsage(key, value);
            } else if (typeof value === 'boolean') {
                incUsage(key, value.toString());
            } else {
                let strValue = value.toISOString();
                incUsage(key, strValue);
            }
        }
    }
    return propertyUsage;

}
